<ng-container *ngIf="form">
  <section class="jurisdiction-card" [formGroup]="form">
    <div class="d-flex flex-column gap-3">
      <div class="d-flex align-items-center" [style.gap.rem]="2.5">
        <div class="flex-grow-1 title-sm">
          <div class="d-flex gap-2 align-items-center">
            <span *ngIf="form.controls.governingJurisdictionId.value">
              {{ form.controls.governingJurisdictionId.value | governingJurisdictionName }}
            </span>
            <span *ngIf="!form.controls.governingJurisdictionId.value" i18n>Non-Locked-In</span>
            <app-status-pill *ngIf="isNew" [statusPill]="newStatusPill" />
          </div>
        </div>
        <div i18n class="paragraph-md secondary-text">Est. Balance: {{ estimatedBalance | currency }}</div>
      </div>
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex flex-column gap-2 mins-and-maxes" [style.max-width.rem]="23.75">
          <div i18n class="paragraph-md secondary-text">Annual Min: {{ minAnnualAmount | currency }}</div>
          <div class="d-flex flex-column gap-1">
            <div i18n class="paragraph-md secondary-text">Annual Max: {{ maxAnnualAmount | currency }}</div>
            <div *ngIf="maximumRaised" class="d-flex gap-1 align-items-center">
              <img
                [src]="'assets/icons/primary/Circle Info.svg'"
                alt=""
                [style.width.rem]="0.875"
                [style.height.rem]="0.875" />
              <span class="caption secondary-text" i18n>
                Maximum raised to the minimum (spousal age minimum election).
              </span>
            </div>
          </div>
          <div class="estimated-total" i18n>
            Est. Annual Total:
            <span *ngIf="!isLoadingAnnualTotal">{{ estimatedAnnualTotal | currency }}</span>
            <span *ngIf="isLoadingAnnualTotal"><lib-loading-shimmer [width]="'5rem'" [height]="'0.75rem'" /></span>
          </div>
          <app-form-error
            *ngIf="formSubmitted && form.controls.hasLumpSumPayment.value && form.errors?.exceedsMaximum"
            [errors]="form.errors"
            [customErrorMessages]="customErrorMessages?.estimatedMax" />
        </div>
        <ng-container *ngIf="!form.controls.hasLumpSumPayment.value">
          <app-text-button
            [type]="ButtonTypeEnum.accent"
            [disabled]="disabled"
            (buttonClicked)="createLumpSumPayment()">
            <div class="d-flex align-items-center gap-2">
              <img src="assets/icons/primary/Plus.svg" [style.width.rem]="1.125" [style.height.rem]="1.125" alt="" />
              <span i18n>Add Lump Sum Payment</span>
            </div>
          </app-text-button>
        </ng-container>
        <ng-container *ngIf="form.controls.hasLumpSumPayment.value">
          <div class="d-flex flex-column gap-2">
            <div class="d-flex flex-column gap-1" [style.width.rem]="18.75">
              <label
                i18n
                class="form-input-label"
                [for]="form.controls.governingJurisdictionId.value + '-lump-sum-amount'"
                >Payment Amount</label
              >
              <app-currency-input
                formControlName="lumpSumPaymentAmount"
                [error]="
                  formSubmitted &&
                  (form.controls.lumpSumPaymentAmount.errors ||
                    (paymentFrequency === VariableBenefitPaymentFrequencyEnum.Annual &&
                      form.controls.hasLumpSumPayment.value &&
                      form.errors?.exceedsMaximum))
                "
                [controlId]="form.controls.governingJurisdictionId.value + '-lump-sum-amount'" />
              <app-form-error
                *ngIf="formSubmitted && form?.controls?.lumpSumPaymentAmount?.invalid"
                [errors]="form?.controls?.lumpSumPaymentAmount?.errors"
                [customErrorMessages]="customErrorMessages?.lumpSumPaymentAmount" />
            </div>
            <app-text-button
              *ngIf="!disabled"
              class="d-flex justify-content-end"
              i18n
              [type]="ButtonTypeEnum.negative"
              (buttonClicked)="removeLumpSumPayment()"
              >Remove</app-text-button
            >
          </div>
        </ng-container>
      </div>
    </div>
  </section>
</ng-container>
